module.exports = __webpack_public_path__ + "media/images/new_landing/people/jirka-fabian-84ec645862cefb3a36eb32aae0163e91.jpg";